var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header_content"},[_vm._m(0),_c('a-button',{on:{"click":_vm.logout}},[_vm._v("退出")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("assets/images/logo.png")}}),_c('span',[_vm._v("VB-MAPP评估系统")])])
}]

export { render, staticRenderFns }